import { z } from 'zod';

// =============================================================================
// Charla / FR-COMUNICACION enums
// =============================================================================

export const CommunicationStatusEnum = z.enum(['DRAFT', 'COMPLETADA']);
export type CommunicationStatus = z.infer<typeof CommunicationStatusEnum>;

// =============================================================================
// Charla request schemas
// =============================================================================

export const CharlaCreateSchema = z.object({
  ambitoId: z.number().int().positive().optional(),
  otId: z.number().int().positive().optional(),
  tipo: z.string().min(1).max(50),
  fecha: z.string().datetime(),
  horaInicio: z.string().regex(/^\d{2}:\d{2}$/, 'Formato HH:MM'),
  horaTermino: z.string().regex(/^\d{2}:\d{2}$/, 'Formato HH:MM'),
  tema: z.string().min(1).max(500),
  observaciones: z.string().optional(),
  preguntasResso: z.array(z.number().int().min(1).max(14)).default([]),
});
export type CharlaCreateInput = z.infer<typeof CharlaCreateSchema>;

export const CharlaUpdateSchema = CharlaCreateSchema.partial();
export type CharlaUpdateInput = z.infer<typeof CharlaUpdateSchema>;

export const CharlaParticipanteAddSchema = z.object({
  usuarioId: z.number().int().positive().optional(),
  nombreManual: z.string().max(200).optional(),
  rutManual: z.string().max(20).optional(),
  signatureS3Key: z.string().min(1),
});
export type CharlaParticipanteAddInput = z.infer<typeof CharlaParticipanteAddSchema>;

export const CharlaCompleteSchema = z.object({
  observacionesFinales: z.string().optional(),
});
export type CharlaCompleteInput = z.infer<typeof CharlaCompleteSchema>;

// =============================================================================
// Response DTOs
// =============================================================================

export const CharlaDTOSchema = z.object({
  id: z.number(),
  empresaId: z.number(),
  leaderId: z.number(),
  tipo: z.string(),
  fecha: z.string(),
  horaInicio: z.string(),
  horaTermino: z.string(),
  duracionMinutos: z.number(),
  tema: z.string(),
  preguntasResso: z.array(z.number()),
  status: CommunicationStatusEnum,
  completedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type CharlaDTO = z.infer<typeof CharlaDTOSchema>;
